export default {
  tryNow: "Try Now",
  retry: "Try Again",
  back: "Back to Home",
  backToList: "Back to Articles",
  read: "Read More",
  readMore: "Read More →",
  filter: "Filter by Category",
  all: "All Articles",
  articles: "articles",
  noData: "No articles found",
  tryDifferentFilter: "Try selecting a different category",
  loading: "Loading...",
  notFound: "Article not found",
  articleNotFound:
    "The article you are looking for does not exist or has been deleted",
  previous: "Previous",
  next: "Next",
  previousArticle: "Previous Article",
  nextArticle: "Next Article",
  relatedArticles: "Related Articles",
  topicNotFound: "Topic not found",
  topicNotFoundDescription: "The topic you are looking for does not exist.",
  noArticles: "No articles yet",
  noArticlesDescription: "There are no articles in this category yet.",
  explore: "Explore",
  allArticles: "All Articles",
  browseBlog: "Browse Blog",
  categories: "Categories",
  popularTags: "Popular Tags",
  showAllTags: "Show all tags",
  showFewerTags: "Show fewer tags",
};
